<div class="background-image-container">
  <div class="container">
    <div class="home-news-content">
      <div class="d-flex">
        <div>
          <h1>I-EMeRG Digital Library</h1>
        </div>
      </div>
    </div>
  </div>
</div>
